export default __webpack_public_path__ + "static/media/applestore.79f3686d.svg";